import type { FormatOptions } from './types.js'

const sanitizeNonNumeric = (locale: string, value: string) =>
  locale === 'en'
    ? Number(String(value).replace(/[^0-9.]/g, ''))
    : Number(
        String(value)
          .replace(/[^0-9,]/g, '')
          .replace(/,/g, '.')
      )

const formatters: Record<string, Intl.NumberFormat> = {}

const getFormatter = (locale: string, withCurrency: boolean, precision: number, useGrouping: boolean) => {
  const currencyKey = withCurrency ? 'currency' : 'noCurrency'
  const key = `${locale}-${currencyKey}-${precision}-${useGrouping}`
  let formatter = formatters[key]
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale ?? 'de', {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
      ...(withCurrency ? { style: 'currency', currency: 'EUR' } : {}),
      ...(!useGrouping ? { useGrouping: false } : {}),
    })
    formatters[key] = formatter
  }
  return formatter
}

 
export default function formatMoney(locale: string, argValue: string | number, options: FormatOptions = {}) {
  const precision = options?.precision === undefined ? 2 : options?.precision
  const sanitisedValue = typeof argValue === 'number' ? argValue || 0 : sanitizeNonNumeric(locale, argValue)
  const thousandSeparator = options?.thousandSeparator ?? true
  const formatter = getFormatter(locale, !options?.format, precision, thousandSeparator)
  const result = formatter.format(sanitisedValue).replace(/\u00A0/, '\u202F')
  return result
}
